import moment, { Moment } from "moment";
import { convertFromIso8601ToEpochNumber } from "../date-time-iso-8601-converter";

/** Last day in lead time on which a booking could be made */
export function getBookingLeadTime(officeTimeZone: string, resourcesBookableUntil?: string): Moment {
  if (!resourcesBookableUntil) {
    return moment().tz(officeTimeZone).endOf("day");
  }

  return moment(convertFromIso8601ToEpochNumber(resourcesBookableUntil)).tz(officeTimeZone);
}
